const newsArticles = [
  {
    id: 1,
    title: "Welcome to Bharwaliya Online",
    date: "October 15, 2023",
    content:
      "We are thrilled to announce the launch of our new online platform. Shop the best in Home & Kitchen organizers right here!",
    author: "Seema Devi",
  },
  {
    id: 2,
    title: "E-commerce Marketing Trends in 2024",
    date: "November 2, 2023",
    content:
      "The e-commerce landscape is shifting towards more sustainable packaging and faster delivery. Discover how Bharwaliya is adapting to serve you better.",
    author: "Marketing Team",
  },
  {
    id: 3,
    title: "Agentic AI Takes Over Retail Operations and Inventory Balancing",
    date: "January 7, 2026",
    content:
      "Retailers are deploying autonomous AI agents to manage backend logistics. Over 47% of retail organizations are piloting or actively using agentic AI to handle real-time inventory rebalancing across warehouses, dynamic pricing, and automated vendor negotiations.",
    author: "Retail Technology Team",
    source: "https://blogs.nvidia.com/blog/ai-in-retail-cpg-survey-2026/"
  },
  {
    id: 4,
    title: "AI Search Shift Makes Retail's Long-Tail Inventory Pay Off",
    date: "August 13, 2026",
    content:
      "Instead of relying solely on homepage promotions or paid ads, retailers are benefiting from AI-referred discovery. Shopify reported that 75% of AI-attributed sales now come from outside top-selling product categories, bringing visibility to niche inventory.",
    author: "E-Commerce Strategy Insights",
    source: "https://www.pymnts.com/news/retail/2026/ai-just-made-retails-long-tail-pay-off/"
  },
  {
    id: 5,
    title: "Physical AI and Autonomous Systems Streamline In-Store Operations",
    date: "January 7, 2026",
    content:
      "In-store robotics and physical AI systems are becoming critical infrastructure for brick-and-mortar stores. Retailers are deploying shelf-scanning bots and computer vision to monitor stock levels in real time and optimize fulfillment speeds.",
    author: "Supply Chain & Ops Team",
    source: "https://blogs.nvidia.com/blog/ai-in-retail-cpg-survey-2026/"
  },
  {
    id: 6,
    title: "AI Engines Transform Retail Discovery Ahead of Holiday Season",
    date: "August 12, 2026",
    content:
      "Industry experts highlight that AI answer engines are fundamentally altering product discovery. Retailers are focusing on Answer Engine Optimization (AEO) to ensure their product specs and availability are formatted cleanly for AI recommendations.",
    author: "Digital Experience Desk",
    source: "https://www.retailtouchpoints.com/features/holiday-26-will-feel-different-from-ai-to-consumer-behavior-retail-experts-weigh-in-on-what-to-expect/620913/"
  },
  {
    id: 7,
    title: "Retail AI Shifts From Feature Add-On to Operational Core Layer",
    date: "March 24, 2026",
    content:
      "Major global retailers are shifting AI implementation out of isolated labs and directly into core operating frameworks. Modern implementations focus on mitigating supply chain volatility, dynamic price optimization, and call-center volume management.",
    author: "Market Analytics Group",
    source: "https://www.capgemini.com/insights/research-library/from-hype-to-how-retail-ai-trends-2026/"
  },
  {
    id: 8,
    title: "AI-Driven Hyper-Personalization Boosts Retail Loyalty Engagement",
    date: "May 26, 2026",
    content:
      "Retail brands are moving beyond traditional point systems by utilizing real-time behavioral data. AI engines analyze past transactions alongside contextual signals to deliver hyper-targeted content and high-conversion recommendations.",
    author: "Marketing Team",
    source: "https://insiderone.com/ai-retail-trends/"
  }
];

export default newsArticles;
